module.exports = __webpack_public_path__ + "assets/images/app_download.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/app_download.png
// module id = 395
// module chunks = 1